// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { GetProductApiV2ParameterBase } from "@insite/client-framework/Services/ProductServiceV2";
import { CatalogPageModel, ProductModel } from "@insite/client-framework/Types/ApiModels";

const catalogPagesUrl = "/api/v1/catalogpages";
const productsUrl = "/api/v2/products";

export interface CustomGetProductByPathApiV2Parameter extends GetProductApiV2ParameterBase {
    path: string;
    styledOption?: string;
    addToRecentlyViewed?: boolean;
    getLastPurchase?: boolean;
    getProductAdditionalInfo?: boolean;
}

export async function getProductByPath(parameter: CustomGetProductByPathApiV2Parameter) {
    const result = await get<CatalogPageModel>(`${catalogPagesUrl}`, { path: parameter.path } as ApiParameter);
    const productModel = await get<ProductModel>(`${productsUrl}/${result.productId}`, {
        expand: parameter.expand,
        additionalExpands: parameter.additionalExpands,
        includeAttributes: parameter.includeAttributes,
        addToRecentlyViewed: parameter.addToRecentlyViewed,
        getLastPurchase: parameter.getLastPurchase,
        getProductAdditionalInfo: parameter.getProductAdditionalInfo,
    } as ApiParameter);

    return productModel;
}
